import React, { useState, useEffect } from 'react';
import InputList from './InputList';

const IL_MissingInformation = ({
  questionnaireCriteria,
  onCriteriaChange,
  label = "Missing Information",
  placeholder = "Enter missing information...",
  emptyMessage = "No missing information added yet"
}) => {

  // Extract missing information from questionnaire criteria
  const getInitialMissingInformation = () => {
    if (questionnaireCriteria?.missingInformation?.items) {
      return questionnaireCriteria.missingInformation.items.map(item => ({
        title: item.topic,
        subtitle: item.rationale || ''
      }));
    }
    return [];
  };

  // State for missing information
  const [missingInformation, setMissingInformation] = useState(getInitialMissingInformation());

  // Update missing information when questionnaireCriteria changes
  useEffect(() => {
    setMissingInformation(getInitialMissingInformation());
  }, [questionnaireCriteria]);

  // Update missing information criteria JSON
  const updateMissingInformationCriteria = (newMissingInformation) => {
    if (!questionnaireCriteria) return;

    // Create updated criteria with new missing information
    const updatedCriteria = {
      ...questionnaireCriteria,
      missingInformation: {
        ...questionnaireCriteria.missingInformation,
        items: newMissingInformation.map(topicItem => {
          // Check if this topic already exists in our current criteria
          const existingTopic = questionnaireCriteria.missingInformation?.items?.find(
            item => item.topic === topicItem.title
          );
          
          if (existingTopic) {
            // Keep existing topic with all its properties
            return existingTopic;
          } else {
            // Create new topic entry with missingInformation specific structure
            return {
              topic: topicItem.title,
              rationale: topicItem.subtitle || ""
            };
          }
        })
      }
    };

    // Call parent callback with only the updated criteria
    onCriteriaChange(updatedCriteria);
  };

  // Handle missing information change
  const handleMissingInformationChange = (newMissingInformation) => {
    setMissingInformation(newMissingInformation);
    updateMissingInformationCriteria(newMissingInformation);
  };

  return (
    <InputList
      items={missingInformation}
      onItemsChange={handleMissingInformationChange}
      label={label}
      placeholder={placeholder}
      emptyMessage={emptyMessage}
    />
  );
};

export default IL_MissingInformation;
